import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, gbp } from "../../lib/api";

const STATUSES = ["awaiting_payment", "paid", "dispatched", "collected", "cancelled"];

export const AdminOrders = () => {
  const [orders, setOrders] = useState([]);

  const load = () => api.get("/admin/orders").then(({ data }) => setOrders(data));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.patch(`/admin/orders/${id}`, { status });
    toast.success("Order status updated");
    load();
  };

  return (
    <div className="border border-[#27272A] overflow-x-auto">
      <table className="w-full text-xs sm:text-sm min-w-[760px]" data-testid="admin-orders-table">
        <thead>
          <tr className="text-left text-white/40 uppercase text-[10px] tracking-widest border-b border-[#27272A]">
            <th className="px-4 py-3">Reference</th><th className="px-4 py-3">Customer</th><th className="px-4 py-3">Items</th>
            <th className="px-4 py-3">Method</th><th className="px-4 py-3 text-right">Total</th><th className="px-4 py-3">Status</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((o) => (
            <tr key={o.id} className="border-b border-[#27272A] last:border-0 hover:bg-[#111111] align-top">
              <td className="px-4 py-3">
                <div className="text-[#FFCC00] font-bold">{o.reference}</div>
                <div className="text-white/30 text-[10px] mt-1">{new Date(o.created_at).toLocaleString("en-GB")}</div>
              </td>
              <td className="px-4 py-3">
                <div>{o.full_name}</div>
                <div className="text-white/40 text-[11px]">{o.postcode} · {o.phone}</div>
              </td>
              <td className="px-4 py-3 text-white/60">
                {o.items.map((i, idx) => <div key={idx}>{i.qty}x {i.title}</div>)}
              </td>
              <td className="px-4 py-3 uppercase text-[11px] text-white/50">{o.delivery_method}</td>
              <td className="px-4 py-3 text-right text-[#FFCC00]">{gbp(o.total)}</td>
              <td className="px-4 py-3">
                <select
                  data-testid={`admin-order-status-${o.reference}`}
                  value={o.status}
                  onChange={(e) => setStatus(o.id, e.target.value)}
                  className="bg-[#111111] border border-[#27272A] px-2 py-1.5 text-[11px] uppercase outline-none focus:border-[#FFCC00]"
                >
                  {STATUSES.map((s) => <option key={s} value={s}>{s.replace("_", " ")}</option>)}
                </select>
              </td>
            </tr>
          ))}
          {orders.length === 0 && <tr><td colSpan={6} className="px-4 py-12 text-center font-display text-2xl text-white/30">NO ORDERS YET.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};
